import { render, staticRenderFns } from "./App.vue?vue&type=template&id=66ab2f82&"
import script from "./App.vue?vue&type=script&lang=js&"
export * from "./App.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/sapphire/K12Live16/build/CommunityWebPortal/_app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66ab2f82')) {
      api.createRecord('66ab2f82', component.options)
    } else {
      api.reload('66ab2f82', component.options)
    }
    module.hot.accept("./App.vue?vue&type=template&id=66ab2f82&", function () {
      api.rerender('66ab2f82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/App.vue"
export default component.exports